<div class="add-order-overlay" *ngIf="isOpen" (click)="onOverlayClick($event)">
  <div class="add-order-panel" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="title">{{ modalTitle }}</div>
      <button class="close-btn" (click)="onClose()" aria-label="Close">✕</button>
    </div>

    <!-- Stepper -->
    <app-order-stepper [tabs]="stepTabs" [activeTabId]="activeStep" [visitedTabs]="visitedSteps">
    </app-order-stepper>

    <!-- Step Content -->
    <div class="content">
      <!-- Step 1: Package Selection -->
      <app-package-step
        *ngIf="activeStep === 'select-car'"
        [selectedPackage]="selectedPackage"
        [sectionTitle]="sectionTitle"
        (selectionChange)="onPackageSelected($event)"
        (continueClicked)="onPackageContinue($event)"
        (cancel)="onClose()"
      >
      </app-package-step>

      <!-- Step 2: Customer Info -->
      <app-customer-info-step
        *ngIf="activeStep === 'customer-info'"
        [locationOptions]="locationOptions"
        [isLoadingLocations]="isLoadingLocations"
        [sectionTitle]="sectionTitle"
        [initialForm]="state.customerForm"
        [initialCustomerId]="state.customerId"
        [initialExistingCustomer]="state.selectedExistingCustomer"
        (customerResolved)="onCustomerResolved($event)"
        (back)="onBack()"
        (cancel)="onClose()"
      >
      </app-customer-info-step>

      <!-- Step 3: Vehicle Details -->
      <app-vehicle-step
        *ngIf="activeStep === 'vehicle-details'"
        [customerId]="state.customerId"
        [isFamilyPlanFromPackage]="state.isSelectedPackageFamilyPlan"
        [sectionTitle]="sectionTitle"
        [stateService]="state"
        (vehiclesReady)="onVehiclesReady($event)"
        (customerFetched)="onCustomerFetched($event)"
        (back)="onBack()"
        (cancel)="onClose()"
      >
      </app-vehicle-step>

      <!-- Step 4: Payment -->
      <app-payment-step
        *ngIf="activeStep === 'payment'"
        [orderId]="state.createdOrderId"
        [stripeAccountId]="state.connectedStripeAccountId"
        [priceBreakdown]="priceBreakdown"
        [summary]="paymentSummary"
        [customerPhone]="state.customerForm.phone"
        [customerEmail]="state.customerForm.email"
        [locationId]="state.selectedLocationId"
        [isMonthly]="state.isMonthlyMembership"
        [sectionTitle]="sectionTitle"
        (paymentSuccess)="onPaymentSuccess()"
        (paymentFailed)="onPaymentFailed($event)"
        (back)="onBack()"
        (cancel)="onClose()"
      >
      </app-payment-step>
    </div>
  </div>
</div>

<!-- Success Modal -->
<app-success-modal
  *ngIf="showPaymentSuccess"
  [isVisible]="showPaymentSuccess"
  [data]="successModalData"
  (action)="onSuccessModalButtonClick()"
  (close)="onSuccessModalClose()"
>
</app-success-modal>

<!-- Order Details Modal -->
<app-order-details-modal
  *ngIf="showOrderDetailsModal"
  [isOpen]="showOrderDetailsModal"
  [order]="selectedOrder"
  (closeModal)="onOrderDetailsClose()"
  (orderCancelled)="onOrderCancelled($event)"
>
</app-order-details-modal>

<!-- Close Confirmation Dialog -->
<app-discard-changes-modal
  [isOpen]="showCloseConfirmationModal"
  (cancel)="onCloseConfirmationCancel()"
  (confirm)="onCloseConfirmationConfirm()"
>
</app-discard-changes-modal>
